module.exports = __webpack_public_path__ + "img/email_verified.c7ece33b.svg";